export enum ClientStatusEnum {
  Active = "Active",
  NotActive = "NotActive",
  Unsubscribed = "Unsubscribed",
  Submitted = "Submitted"
}
